/*
 * useSelect.ts
 *
 * @Author: xiaoJQ
 * @Date: 2024-06-17 17:12:36
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import { useSelector as useSelectorOrigin, } from 'react-redux';
export var useSelector = useSelectorOrigin;
